export { default } from "./BedroomsIcon";
